import { useHistory } from 'react-router-dom';

const useCourses = () => {
  const history = useHistory();

  const sendToCourses = response => {
    history.replace({
      pathname: '/cursos',
      state: {
        isComingFrom: '/cursos/editar/publicar',
        successful: response,
      },
    });
  };

  return { sendToCourses };
};
export default useCourses;
